import * as React from "react";
import type { SVGProps } from "react";
const SvgListNumbers = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10.8 4.8h10.8M10.8 12h10.8M12 19.2h9.6M2.4 16.8a2.4 2.4 0 0 1 4.8 0c0 .71-.6 1.2-1.2 1.8l-3.6 3h4.8m-2.4-12V2.4L2.4 4.8"
    />
  </svg>
);
export default SvgListNumbers;
